module.exports = __webpack_public_path__ + "static/media/MZ.8a7e86df.png";